export default [{
	"label": "南非荷蘭文",
	"value": "af-ZA"
}, {
	"label": "南非人（納米比亞）",
	"value": "en-US"
}, {
	"label": "阿爾巴尼亞文",
	"value": "sq-AL"
}, {
	"label": "阿爾巴尼亞文（科索沃）",
	"value": "en-US"
}, {
	"label": "亞爾薩斯語 (法國)",
	"value": "gsw-FR"
}, {
	"label": "阿姆哈拉文",
	"value": "am-ET"
}, {
	"label": "阿拉伯文",
	"value": "ar-SA"
}, {
	"label": "阿拉伯文 (阿爾及利亞)",
	"value": "ar-DZ"
}, {
	"label": "阿拉伯文 (巴林)",
	"value": "ar-BH"
}, {
	"label": "阿拉伯文 (埃及)",
	"value": "ar-EG"
}, {
	"label": "阿拉伯文 (伊拉克)",
	"value": "ar-IQ"
}, {
	"label": "阿拉伯文 (約旦)",
	"value": "ar-JO"
}, {
	"label": "阿拉伯文 (科威特)",
	"value": "ar-KW"
}, {
	"label": "阿拉伯文 (黎巴嫩)",
	"value": "ar-LB"
}, {
	"label": "阿拉伯文 (利比亞)",
	"value": "ar-LY"
}, {
	"label": "阿拉伯文 (摩洛哥)",
	"value": "ar-MA"
}, {
	"label": "阿拉伯文 (阿曼)",
	"value": "ar-OM"
}, {
	"label": "阿拉伯文 (卡達)",
	"value": "ar-QA"
}, {
	"label": "阿拉伯文 (敘利亞)",
	"value": "ar-SY"
}, {
	"label": "阿拉伯文 (突尼西亞)",
	"value": "ar-TN"
}, {
	"label": "阿拉伯文 (阿拉伯聯合大公國)",
	"value": "ar-AE"
}, {
	"label": "阿拉伯文（世界）",
	"value": "en-US"
}, {
	"label": "阿拉伯文 (葉門)",
	"value": "ar-YE"
}, {
	"label": "亞美尼亞文",
	"value": "hy-AM"
}, {
	"label": "阿薩姆文",
	"value": "as-IN"
}, {
	"label": "阿圖里亞文",
	"value": "es-ES_tradnl"
}, {
	"label": "亞塞拜然文",
	"value": "az-Latn-AZ"
}, {
	"label": "亞塞拜然（斯拉夫）",
	"value": "az-Cyrl-AZ"
}, {
	"label": "孟加拉文",
	"value": "bn-BD"
}, {
	"label": "巴什喀爾文",
	"value": "ba-RU"
}, {
	"label": "巴斯克文",
	"value": "eu-ES"
}, {
	"label": "比利時語",
	"value": "be-BY"
}, {
	"label": "孟加拉文 (印度)",
	"value": "bn-IN"
}, {
	"label": "博多语",
	"value": "hi-IN"
}, {
	"label": "波士尼亞文",
	"value": "bs-Latn-BA"
}, {
	"label": "波士尼亞文 (斯拉夫)",
	"value": "bs-Cyrl-BA"
}, {
	"label": "布列塔尼",
	"value": "br-FR"
}, {
	"label": "保加利亞文",
	"value": "bg-BG"
}, {
	"label": "緬甸",
	"value": "my-MM"
}, {
	"label": "加泰蘭文",
	"value": "ca-ES"
}, {
	"label": "加泰隆尼亞文（薩摩亞）",
	"value": "fr-FR"
}, {
	"label": "加泰隆尼亞文（法國）",
	"value": "fr-FR"
}, {
	"label": "加泰隆尼亞 （義大利）",
	"value": "it-IT"
}, {
	"label": "中央阿特拉斯·塔馬澤特",
	"value": "tzm-Latn-TZ"
}, {
	"label": "中央阿特拉斯·塔馬澤特（阿拉伯文）",
	"value": "ar-MA"
}, {
	"label": "中央阿特拉斯·塔馬澤特（蒂維納）",
	"value": "tzm-Tfng-MA"
}, {
	"label": "中部庫德文",
	"value": "ku-Arab-IQ"
}, {
	"label": "車臣",
	"value": "ru-RU"
}, {
	"label": "切 諾 基",
	"value": "chr-Cher-US"
}, {
	"label": "中文",
	"value": "zh-CN"
}, {
	"label": "中文（簡體，香港特別行政區）",
	"value": "en-US"
}, {
	"label": "中文（簡體、澳門特別行政區）",
	"value": "en-US"
}, {
	"label": "中文 (繁體)",
	"value": "zh-TW"
}, {
	"label": "中文 (繁體，台灣)",
	"value": "zh-TW"
}, {
	"label": "教堂斯拉維奇",
	"value": "ru-RU"
}, {
	"label": "科隆方言",
	"value": "de-DE"
}, {
	"label": "康沃爾",
	"value": "en-GB"
}, {
	"label": "科西坎",
	"value": "co-FR"
}, {
	"label": "克羅埃西亞文",
	"value": "hr-HR"
}, {
	"label": "克羅埃西亞文（波士尼亞 - 黑塞哥維那）",
	"value": "hr-BA"
}, {
	"label": "捷克文",
	"value": "cs-CZ"
}, {
	"label": "丹麥文",
	"value": "da-DK"
}, {
	"label": "丹麥文（格陵蘭）",
	"value": "da-DK"
}, {
	"label": "迪維西文",
	"value": "dv-MV"
}, {
	"label": "荷蘭文",
	"value": "nl-NL"
}, {
	"label": "荷蘭文（阿路巴）",
	"value": "en-US"
}, {
	"label": "荷蘭文 (比利時)",
	"value": "nl-BE"
}, {
	"label": "荷蘭文（博奈爾、聖尤斯塔修斯和薩巴）",
	"value": "en-US"
}, {
	"label": "荷蘭文（古拉梳）",
	"value": "en-US"
}, {
	"label": "荷蘭文（聖馬滕）",
	"value": "en-US"
}, {
	"label": "荷蘭文（蘇利南）",
	"value": "en-US"
}, {
	"label": "宗卡",
	"value": "dz-BT"
}, {
	"label": "英語",
	"value": "en-US"
}, {
	"label": "英文 (澳大利亞)",
	"value": "en-AU"
}, {
	"label": "英文（奧地利）",
	"value": "en-GB"
}, {
	"label": "英文（比利時）",
	"value": "fr-BE"
}, {
	"label": "英文 (貝里斯)",
	"value": "en-BZ"
}, {
	"label": "英文（英屬維爾京群島）",
	"value": "en-GB"
}, {
	"label": "英文（蒲隆地）",
	"value": "en-GB"
}, {
	"label": "英文 (加拿大)",
	"value": "en-CA"
}, {
	"label": "英文 (加勒比海)",
	"value": "en-029"
}, {
	"label": "英文（丹麥）",
	"value": "en-US"
}, {
	"label": "英文（福克蘭群島）",
	"value": "en-GB"
}, {
	"label": "英文（芬蘭）",
	"value": "en-GB"
}, {
	"label": "英文（德國）",
	"value": "en-GB"
}, {
	"label": "英文（直布羅陀）",
	"value": "en-GB"
}, {
	"label": "英文（根西）",
	"value": "en-GB"
}, {
	"label": "英文（香港特別行政區）",
	"value": "en-HK"
}, {
	"label": "英文 (印度)",
	"value": "en-IN"
}, {
	"label": "英文 (愛爾蘭)",
	"value": "en-IE"
}, {
	"label": "英文（曼島）",
	"value": "en-GB"
}, {
	"label": "英文（以色列）",
	"value": "en-US"
}, {
	"label": "英文 (牙買加)",
	"value": "en-JM"
}, {
	"label": "英文（澤西）",
	"value": "en-GB"
}, {
	"label": "英文 (馬來西亞)",
	"value": "en-MY"
}, {
	"label": "英文（馬爾他）",
	"value": "en-GB"
}, {
	"label": "英文（荷蘭）",
	"value": "en-GB"
}, {
	"label": "英文 (紐西蘭)",
	"value": "en-NZ"
}, {
	"label": "英文 (菲律賓)",
	"value": "en-PH"
}, {
	"label": "英文 (新加坡)",
	"value": "en-SG"
}, {
	"label": "英文（斯洛維尼亞）",
	"value": "en-GB"
}, {
	"label": "英文 (南非)",
	"value": "en-ZA"
}, {
	"label": "英文（瑞典）",
	"value": "en-GB"
}, {
	"label": "英文（瑞士）",
	"value": "en-GB"
}, {
	"label": "英文（特立尼達和多巴哥）",
	"value": "en-TT"
}, {
	"label": "英文 (英國)",
	"value": "en-GB"
}, {
	"label": "英文 (辛巴威)",
	"value": "en-ZW"
}, {
	"label": "愛沙尼亞文",
	"value": "et-EE"
}, {
	"label": "法羅語",
	"value": "fo-FO"
}, {
	"label": "菲律賓文",
	"value": "fil-PH"
}, {
	"label": "芬蘭文",
	"value": "fi-FI"
}, {
	"label": "法文",
	"value": "fr-FR"
}, {
	"label": "法文 (比利時)",
	"value": "fr-BE"
}, {
	"label": "法文（喀麥隆）",
	"value": "fr-CM"
}, {
	"label": "法文 (加拿大)",
	"value": "fr-CA"
}, {
	"label": "法國（象牙海岸）",
	"value": "fr-CI"
}, {
	"label": "法文（海地）",
	"value": "fr-HT"
}, {
	"label": "法文 (盧森堡)",
	"value": "fr-LU"
}, {
	"label": "法文（馬里）",
	"value": "fr-ML"
}, {
	"label": "法文 (摩納哥)",
	"value": "fr-MC"
}, {
	"label": "法國（摩洛哥）",
	"value": "fr-MA"
}, {
	"label": "法文（留尼翁）",
	"value": "fr-RE"
}, {
	"label": "法文（塞內加爾）",
	"value": "fr-SN"
}, {
	"label": "法文 (瑞士)",
	"value": "fr-CH"
}, {
	"label": "法國剛果（金）",
	"value": "fr-CD"
}, {
	"label": "弗里利亞文",
	"value": "it-IT"
}, {
	"label": "富拉",
	"value": "ff-Latn-SN"
}, {
	"label": "富拉（阿德拉姆）",
	"value": "en-US"
}, {
	"label": "富拉（拉丁，布吉納法索）",
	"value": "en-US"
}, {
	"label": "富拉（拉丁，喀麥隆）",
	"value": "wo-SN"
}, {
	"label": "富拉（拉丁，甘比亞）",
	"value": "wo-SN"
}, {
	"label": "富拉（拉丁，迦納）",
	"value": "wo-SN"
}, {
	"label": "富拉（拉丁，幾內亞）",
	"value": "wo-SN"
}, {
	"label": "富拉（拉丁，賴比瑞亞）",
	"value": "wo-SN"
}, {
	"label": "富拉（拉丁，茅利塔尼亞）",
	"value": "wo-SN"
}, {
	"label": "富拉（拉丁，尼日爾）",
	"value": "wo-SN"
}, {
	"label": "富拉（拉丁，奈及利亞）",
	"value": "wo-SN"
}, {
	"label": "富拉（拉丁，塞拉利昂）",
	"value": "wo-SN"
}, {
	"label": "加利西亞文",
	"value": "gl-ES"
}, {
	"label": "喬治亞文",
	"value": "ka-GE"
}, {
	"label": "德文",
	"value": "de-DE"
}, {
	"label": "德文 (奧地利)",
	"value": "de-AT"
}, {
	"label": "德文（比利時）",
	"value": "fr-BE"
}, {
	"label": "德文（義大利）",
	"value": "en-US"
}, {
	"label": "德文 (列支敦斯登)",
	"value": "de-LI"
}, {
	"label": "德文 (盧森堡)",
	"value": "de-LU"
}, {
	"label": "德文 (瑞士)",
	"value": "de-CH"
}, {
	"label": "希臘文",
	"value": "el-GR"
}, {
	"label": "瓜拉尼",
	"value": "gn-PY"
}, {
	"label": "古吉拉特文",
	"value": "gu-IN"
}, {
	"label": "豪薩",
	"value": "ha-Latn-NG"
}, {
	"label": "夏威夷",
	"value": "haw-US"
}, {
	"label": "希伯来语",
	"value": "he-IL"
}, {
	"label": "印度文",
	"value": "hi-IN"
}, {
	"label": "匈牙利文",
	"value": "hu-HU"
}, {
	"label": "冰島文",
	"value": "is-IS"
}, {
	"label": "伊博",
	"value": "ig-NG"
}, {
	"label": "印尼文",
	"value": "id-ID"
}, {
	"label": "国际语",
	"value": "fr-FR"
}, {
	"label": "依奴提圖特文",
	"value": "iu-Latn-CA"
}, {
	"label": "伊努克特文（教學課程）",
	"value": "iu-Cans-CA"
}, {
	"label": "愛爾蘭文",
	"value": "ga-IE"
}, {
	"label": "愛爾蘭文（英國）",
	"value": "en-US"
}, {
	"label": "義大利文",
	"value": "it-IT"
}, {
	"label": "義大利文 (瑞士)",
	"value": "it-CH"
}, {
	"label": "義大利文（梵蒂岡城）",
	"value": "en-US"
}, {
	"label": "日文",
	"value": "ja-JP"
}, {
	"label": "爪 哇",
	"value": "jv"
}, {
	"label": "格陵兰语",
	"value": "kl-GL"
}, {
	"label": "坎那達文",
	"value": "kn-IN"
}, {
	"label": "喀什米爾",
	"value": "your-PK"
}, {
	"label": "克什米里（德瓦納加里）",
	"value": "hi-IN"
}, {
	"label": "哈薩克文",
	"value": "kk-KZ"
}, {
	"label": "高棉文",
	"value": "km-KH"
}, {
	"label": "基尼阿万达语",
	"value": "rw-RW"
}, {
	"label": "斯瓦希里语",
	"value": "sw-KE"
}, {
	"label": "基斯瓦希利（剛果））",
	"value": "en-US"
}, {
	"label": "基斯瓦希利（坦尚尼亞）",
	"value": "en-US"
}, {
	"label": "基斯瓦希利（烏干達）",
	"value": "en-US"
}, {
	"label": "孔卡尼语",
	"value": "kok-IN"
}, {
	"label": "韓文",
	"value": "ko-KR"
}, {
	"label": "韓文（朝鮮）",
	"value": "en-US"
}, {
	"label": "吉爾吉斯文",
	"value": "ky-KG"
}, {
	"label": "基切语",
	"value": "quc-Latn-GT"
}, {
	"label": "寮文",
	"value": "lo-LA"
}, {
	"label": "拉脫維亞文",
	"value": "lv-LV"
}, {
	"label": "立陶宛文",
	"value": "lt-LT"
}, {
	"label": "下索比安",
	"value": "dsb-DE"
}, {
	"label": "盧森堡文",
	"value": "lb-LU"
}, {
	"label": "馬其頓文",
	"value": "mk-MK"
}, {
	"label": "馬達加斯加文",
	"value": "mg"
}, {
	"label": "馬來文",
	"value": "ms-MY"
}, {
	"label": "馬來文（汶萊）",
	"value": "ms-BN"
}, {
	"label": "馬來語 （印尼）",
	"value": "en-US"
}, {
	"label": "馬來文（新加坡）",
	"value": "en-US"
}, {
	"label": "馬來亞拉姆文",
	"value": "ml-IN"
}, {
	"label": "馬爾他文",
	"value": "mt-MT"
}, {
	"label": "曼尼普尔语",
	"value": "en-IN"
}, {
	"label": "马恩岛语",
	"value": "en-GB"
}, {
	"label": "毛利文",
	"value": "mi-NZ"
}, {
	"label": "马普切语",
	"value": "arn-CL"
}, {
	"label": "馬拉地文",
	"value": "mr-IN"
}, {
	"label": "馬讚達尼",
	"value": "fa-IR"
}, {
	"label": "莫霍克",
	"value": "moh-CA"
}, {
	"label": "蒙古文",
	"value": "mn-MN"
}, {
	"label": "蒙古文（蒙古文）",
	"value": "mn-Mong-CN"
}, {
	"label": "蒙古文（蒙古傳統蒙古文）",
	"value": "mn-Mong-MN"
}, {
	"label": "恩科语",
	"value": "nqo"
}, {
	"label": "尼泊爾文",
	"value": "ne-NP"
}, {
	"label": "尼泊爾文（印度）",
	"value": "ne-IN"
}, {
	"label": "北盧里",
	"value": "ar-IQ"
}, {
	"label": "北薩米文",
	"value": "se-NO"
}, {
	"label": "挪威文",
	"value": "nb-NO"
}, {
	"label": "耐諾斯克挪威文",
	"value": "nn-NO"
}, {
	"label": "奥克语",
	"value": "oc-FR"
}, {
	"label": "歐迪亞文",
	"value": "or-IN"
}, {
	"label": "奥罗莫语",
	"value": "om-ET"
}, {
	"label": "奧羅莫（肯亞）",
	"value": "en-US"
}, {
	"label": "奥塞梯语",
	"value": "ru-RU"
}, {
	"label": "帕皮亞門托",
	"value": "pap-029"
}, {
	"label": "普什圖文",
	"value": "ps-AF"
}, {
	"label": "普什托（巴基斯坦）",
	"value": "en-US"
}, {
	"label": "波斯文",
	"value": "fa-IR"
}, {
	"label": "波斯文（阿富汗）",
	"value": "fa-AF"
}, {
	"label": "波蘭文",
	"value": "pl-PL"
}, {
	"label": "葡萄牙文",
	"value": "pt-BR"
}, {
	"label": "葡萄牙文（安哥拉）",
	"value": "pt-PT"
}, {
	"label": "葡萄牙文 （卡波維德）",
	"value": "pt-PT"
}, {
	"label": "葡萄牙文（赤道幾內亞）",
	"value": "en-US"
}, {
	"label": "葡萄牙文（幾內亞）",
	"value": "pt-PT"
}, {
	"label": "葡萄牙文（盧森堡）",
	"value": "en-US"
}, {
	"label": "葡萄牙文（澳門特別行政區）",
	"value": "pt-PT"
}, {
	"label": "葡萄牙文（莫三比克）",
	"value": "pt-PT"
}, {
	"label": "葡萄牙文 (葡萄牙)",
	"value": "pt-PT"
}, {
	"label": "葡萄牙文（瑞士）",
	"value": "en-US"
}, {
	"label": "葡萄牙文（聖托梅和普林西比）",
	"value": "pt-PT"
}, {
	"label": "葡萄牙文（東帝汶）",
	"value": "pt-PT"
}, {
	"label": "普魯士",
	"value": "de-DE"
}, {
	"label": "旁遮普文",
	"value": "pa-IN"
}, {
	"label": "旁遮普文",
	"value": "pa-Arab-PK"
}, {
	"label": "克丘亞語",
	"value": "quz-BO"
}, {
	"label": "蓋楚瓦文 (厄瓜多)",
	"value": "quz-EC"
}, {
	"label": "蓋楚瓦文 (秘魯)",
	"value": "quz-PE"
}, {
	"label": "羅馬尼亞文",
	"value": "ro-RO"
}, {
	"label": "羅馬尼亞文（摩爾多瓦）",
	"value": "ro-MD"
}, {
	"label": "罗曼什语",
	"value": "rm-CH"
}, {
	"label": "俄文",
	"value": "ru-RU"
}, {
	"label": "俄羅斯（摩爾多瓦）",
	"value": "en-US"
}, {
	"label": "薩哈文",
	"value": "sah-RU"
}, {
	"label": "薩米（伊納里）",
	"value": "smn-FI"
}, {
	"label": "薩米（盧爾）",
	"value": "smj-SE"
}, {
	"label": "薩米（斯科爾特）",
	"value": "sms-FI"
}, {
	"label": "薩米（南方）",
	"value": "sma-SE"
}, {
	"label": "薩米，盧爾（挪威）",
	"value": "smj-NO"
}, {
	"label": "北薩米（芬蘭）",
	"value": "se-FI"
}, {
	"label": "薩米，北方（瑞典）",
	"value": "se-SE"
}, {
	"label": "南薩米（挪威）",
	"value": "sma-NO"
}, {
	"label": "梵文",
	"value": "sa-IN"
}, {
	"label": "蘇格蘭蓋爾文",
	"value": "gd-GB"
}, {
	"label": "塞爾維亞文",
	"value": "sr-Latn-RS"
}, {
	"label": "塞爾維亞文 (斯拉夫)",
	"value": "sr-Cyrl-RS"
}, {
	"label": "塞爾維亞文 (斯拉夫、波士尼亞與赫塞哥維納)",
	"value": "sr-Cyrl-BA"
}, {
	"label": "塞爾維亞文（斯拉夫，科索沃）",
	"value": "en-US"
}, {
	"label": "塞爾維亞文（斯拉夫，黑山）",
	"value": "sr-Cyrl-ME"
}, {
	"label": "塞爾維亞文（拉丁，波士尼亞- 黑塞哥維那）",
	"value": "sr-Latn-BA"
}, {
	"label": "塞爾維亞文（拉丁，科索沃）",
	"value": "en-US"
}, {
	"label": "塞爾維亞文（拉丁，黑山）",
	"value": "sr-Latn-ME"
}, {
	"label": "索托",
	"value": "st-ZA"
}, {
	"label": "索托托（賴索托）",
	"value": "en-US"
}, {
	"label": "塞索托薩·萊博亞",
	"value": "nso-ZA"
}, {
	"label": "塞茨瓦纳语",
	"value": "tn-ZA"
}, {
	"label": "塞茲瓦納（波札那）",
	"value": "tn-BW"
}, {
	"label": "绍纳语",
	"value": "jv"
}, {
	"label": "辛蒂",
	"value": "sd-Arab-PK"
}, {
	"label": "辛蒂（德瓦納加里）",
	"value": "hi-IN"
}, {
	"label": "僧伽羅文",
	"value": "si-LK"
}, {
	"label": "斯洛伐克文",
	"value": "sk-SK"
}, {
	"label": "斯洛維尼亞文",
	"value": "sl-SI"
}, {
	"label": "索馬里",
	"value": "so-SO"
}, {
	"label": "索馬里（吉布地）",
	"value": "en-US"
}, {
	"label": "索馬里（衣索比亞）",
	"value": "en-US"
}, {
	"label": "索馬里（肯亞）",
	"value": "en-US"
}, {
	"label": "西班牙文",
	"value": "es-ES"
}, {
	"label": "西班牙文 (阿根廷)",
	"value": "es-AR"
}, {
	"label": "西班牙文（貝里斯）",
	"value": "en-US"
}, {
	"label": "西班牙文 (玻利維亞)",
	"value": "es-BO"
}, {
	"label": "西班牙文（巴西）",
	"value": "en-US"
}, {
	"label": "西班牙文 (智利)",
	"value": "es-CL"
}, {
	"label": "西班牙文 (哥倫比亞)",
	"value": "es-CO"
}, {
	"label": "西班牙文 (哥斯大黎加)",
	"value": "es-CR"
}, {
	"label": "西班牙文 (古巴)",
	"value": "es-MX"
}, {
	"label": "西班牙文 (多明尼加)",
	"value": "es-DO"
}, {
	"label": "西班牙文 (厄瓜多)",
	"value": "es-EC"
}, {
	"label": "西班牙文 (薩爾瓦多)",
	"value": "es-SV"
}, {
	"label": "西班牙文 (赤道幾內亞)",
	"value": "es-MX"
}, {
	"label": "西班牙文 (瓜地馬拉)",
	"value": "es-GT"
}, {
	"label": "西班牙文 (宏都拉斯)",
	"value": "es-HN"
}, {
	"label": "西班牙文（拉丁美洲）",
	"value": "es-419"
}, {
	"label": "西班牙文 (墨西哥)",
	"value": "es-MX"
}, {
	"label": "西班牙文 (尼加拉瓜)",
	"value": "es-NI"
}, {
	"label": "西班牙文 (巴拿馬)",
	"value": "es-PA"
}, {
	"label": "西班牙文 (巴拉圭)",
	"value": "es-PY"
}, {
	"label": "西班牙文 (秘魯)",
	"value": "es-PE"
}, {
	"label": "西班牙文（菲律賓）",
	"value": "es-MX"
}, {
	"label": "西班牙文 (波多黎各)",
	"value": "es-PR"
}, {
	"label": "西班牙文 (美國)",
	"value": "es-US"
}, {
	"label": "西班牙文 (烏拉圭)",
	"value": "es-UY"
}, {
	"label": "西班牙文 (委內瑞拉)",
	"value": "es-VE"
}, {
	"label": "標準摩洛哥塔馬塞特",
	"value": "zgh"
}, {
	"label": "瑞典文",
	"value": "sv-SE"
}, {
	"label": "瑞典文 (芬蘭)",
	"value": "sv-FI"
}, {
	"label": "瑞士德文",
	"value": "de-CH"
}, {
	"label": "敘利亞文",
	"value": "syr-SY"
}, {
	"label": "塔切爾希特",
	"value": "tzm-Tfng-MA"
}, {
	"label": "塔切爾希特 （拉丁）",
	"value": "tzm-Latn-TZ"
}, {
	"label": "塔吉克",
	"value": "tg-Cyrl-TJ"
}, {
	"label": "坦米爾文",
	"value": "ta-IN"
}, {
	"label": "坦米爾文 (馬來西亞)",
	"value": "ta-IN"
}, {
	"label": "坦米爾文 (新加坡)",
	"value": "ta-IN"
}, {
	"label": "坦米爾文 (斯里蘭卡)",
	"value": "ta-LK"
}, {
	"label": "韃靼文",
	"value": "tt-RU"
}, {
	"label": "泰盧固文",
	"value": "te-IN"
}, {
	"label": "泰文",
	"value": "th-TH"
}, {
	"label": "藏文",
	"value": "博-CN"
}, {
	"label": "藏文（印度）",
	"value": "bo-CN"
}, {
	"label": "提格利尼亞文",
	"value": "ti-ET"
}, {
	"label": "土耳其文",
	"value": "tr-TR"
}, {
	"label": "土庫曼",
	"value": "tk-TM"
}, {
	"label": "烏克蘭文",
	"value": "uk-UA"
}, {
	"label": "上索布文",
	"value": "hsb-DE"
}, {
	"label": "烏都文",
	"value": "your-PK"
}, {
	"label": "烏都文 (印度)",
	"value": "your-IN"
}, {
	"label": "維吾爾文",
	"value": "ug-CN"
}, {
	"label": "烏茲別克語",
	"value": "uz-Latn-UZ"
}, {
	"label": "烏茲別克文（阿拉伯文）",
	"value": "ps-AF"
}, {
	"label": "瓦倫西亞（西班牙）",
	"value": "ca-ES-瓦倫西亞"
}, {
	"label": "越南文",
	"value": "vi-VN"
}, {
	"label": "瓦尔瑟语",
	"value": "de-CH"
}, {
	"label": "威爾斯文",
	"value": "cy-GB"
}, {
	"label": "西弗里西亞文",
	"value": "fy-NL"
}, {
	"label": "沃洛夫语",
	"value": "wo-SN"
}, {
	"label": "特松加文",
	"value": "ts-ZA"
}, {
	"label": "约鲁巴语",
	"value": "yo-NG"
}, {
	"label": "科萨语",
	"value": "xh-ZA"
}, {
	"label": "祖鲁语",
	"value": "zu-ZA"
}]
